import React from 'react';
import PropTypes from 'prop-types';
import MaskIcon from '../Icons/MaskIcon';
import { isRedMask } from '../../utils/common';

const ProductionMaskIcon = ({ approvedBy, className }) => (
  <MaskIcon isRed={isRedMask(approvedBy)} className={className} />
);

const addedByShape = PropTypes.shape({
  slug: PropTypes.string,
  id: PropTypes.number,
});

ProductionMaskIcon.propTypes = {
  addedBy: addedByShape,
  approvedBy: PropTypes.arrayOf(addedByShape),
  className: PropTypes.string,
};

export default ProductionMaskIcon;
